document.addEventListener('DOMContentLoaded', function() {
    cSlideNewsTorigger();
    cSlideMvTorigger();
});

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
        cSlideNewsTorigger();
        cSlideMvTorigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
        cSlideNewsTorigger();
        cSlideMvTorigger();
    });
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
        cSlideNewsTorigger();
        cSlideMvTorigger();
    });
}


/****************************************
     遅延関数のJS
****************************************/
function customDebounce(func, wait) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}


/****************************************
    メインビジュアルのスライダーJS
****************************************/
function cSlideMvTorigger() {
    if (document.querySelectorAll('.c-mv__section').length) {
        cSlideMv();
    }
};

function cSlideMv() {
    $('.c-mv__section').each(function() {
        const $section = $(this);
        const $slickMain = $(this).find('.slider-main.slider');
        const $slickNav = $(this).find('.slider-nav.slider');

        const blockSize = $section.data('blockSize');
        let slideNum = blockSize;
        let centerModeCheck = true;

        const mediaQuery999 = window.matchMedia('(max-width: 999px)');
        const mediaQuery699 = window.matchMedia('(max-width: 699px)');

        function handleMediaQueryChange() {
            let maxSlideNum;
            if (mediaQuery699.matches) {
                maxSlideNum = 3;
            } else if (mediaQuery999.matches) {
                maxSlideNum = 5;
            } else {
                maxSlideNum = 7;
            }
          
            if (mediaQuery699.matches && blockSize >= maxSlideNum) {
                slideNum = 3;
            } else if (mediaQuery999.matches && blockSize >= maxSlideNum) {
                slideNum = 5;
            } else if (!mediaQuery699.matches && !mediaQuery999.matches && blockSize >= maxSlideNum) {
                slideNum = 7;
            }

            if (blockSize <= maxSlideNum) {
                $section.addClass('c-few-img');
                centerModeCheck = false;
            } else {
                $section.removeClass('c-few-img');
                centerModeCheck = true;
            }

            if ($slickNav.hasClass('slick-initialized')) {
                $slickNav.slick('slickSetOption', 'slidesToShow', slideNum, true);
                $slickNav.slick('slickSetOption', 'centerMode', centerModeCheck, true);
            }
        }

        handleMediaQueryChange();
        const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
        mediaQuery999.addListener(debouncedHandleMediaQueryChange);
        mediaQuery699.addListener(debouncedHandleMediaQueryChange);

        $slickMain.not('.slick-initialized').slick({
           slidesToShow: 1,
           slidesToScroll: 1,
           arrows: false,
           fade: true,
           asNavFor: '.slider-nav'
       });

       $slickNav.not('.slick-initialized').slick({
            slidesToShow: slideNum,
            slidesToScroll: 1,
            centerMode: centerModeCheck,
            centerPadding: "8%",
            asNavFor: '.slider-main',
            prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            dots: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: slideNum,
                        centerPadding: "4%",
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: slideNum,
                        centerPadding: "4%",
                    },
                },
           ],
       });
    });
}


/****************************************
    News一覧のJS
****************************************/
function cSlideNewsTorigger() {
    if (document.querySelectorAll('.c-news__section').length) {
        cSlideNews();
    }
};

function cSlideNews() {
    $('.c-news__section').each(function() {
        const $section = $(this);
        const $slick = $(this).find('.c-news__inner.slider');

        const newsNum = $slick.data('newsNum');
        const slideNum = $slick.data('slideNum');

        const mediaQuery999 = window.matchMedia('(max-width: 999px)');
        const mediaQuery479 = window.matchMedia('(max-width: 479px)');

        function handleMediaQueryChange() {
            let maxArticleNum;
            if (mediaQuery479.matches) {
                maxArticleNum = 1;
            } else if (mediaQuery999.matches) {
                maxArticleNum = 2;
            } else {
                maxArticleNum = 3;
            }

            if (newsNum <= maxArticleNum || slideNum <= maxArticleNum) {
                $section.addClass('c-stack-slick');
            } else {
                $section.removeClass('c-stack-slick');
            }
        }

        handleMediaQueryChange();
        const debouncedHandleMediaQueryChange = customDebounce(handleMediaQueryChange, 200);
        mediaQuery999.addListener(handleMediaQueryChange);
        mediaQuery479.addListener(handleMediaQueryChange);

        $slick.not('.slick-initialized').slick({
            autoplay: false,
            arrows: true,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            prevArrow: '<button class="c-arrow__btn c-arrow__prev animate-icon-horizontal is-reverse md-max-hidden"><span class="c-arrow__svg"></span></button>',
            nextArrow: '<button class="c-arrow__btn c-arrow__next animate-icon-horizontal md-max-hidden"><span class="c-arrow__svg"></span></button>',
            responsive: [
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.3,
                        slidesToScroll: 2,
                        arrows: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.15,
                        slidesToScroll: 1,
                        arrows: false,
                    }
                }
            ]
        });
    });
};
